import React from "react";
import NotFound from "./NotFound/NotFound";

const NotFoundPage = () => {
  return <NotFound />;
};

export default NotFoundPage;
